// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__tVvV4","approved":"Status_approved__SCu0k","rejected":"Status_rejected__3etwJ","expired":"Status_expired__3chCT","label":"Status_label__48nkx"};